import React, { useState, useContext, useEffect } from "react";
import { UserContext } from '../../stores/Context/Context';
export default function Subtabwarpped(props) {
  // Form Validation functions  onely return true or false
  let contT = useContext(UserContext)
  const [tabactive, settabactive] = useState(1)

  const tabactions = (e, index) => {
    settabactive(index)
  }
   
    function isValidatefun() {
      props.setIsSubtap(true)
      let validate = contT.supTabValidation.isValidate();
      let tapLength = props.subTab.length
      let currentStep = tabactive + 1;
      currentStep = currentStep === 0 ? 1 : tapLength <= currentStep ? tapLength : currentStep;
      if(validate){
        settabactive(currentStep)
        if(tapLength <= currentStep ){
          validate=validate

        }else{
          validate=false
        }
      }
      props.setWarppedValidation(validate)
    }
  
    contT.formValidation.isValidate=isValidatefun
  return (
    <div>
      {/* <h1>Third</h1>
      <div className="subtab_title_header"> {props.subTab.map((sub, index) => {
        return (<div key={index} className={`subtab_title ${tabactive  == index + 1 && tabactive == 1 ? "subtab_title_active" : `${tabactive == index + 1 ? "subtab_title_active1" : "subtab_title"}`}`} onClick={(e) => tabactions(e, index + 1)}>
          {sub.suptitle}
        </div>)
      })}</div> */}
           <nav class="top-nav pt-5">
            <ul>
                {/* <li>
                    <a className="top-menu top-menu--active">
                        <div class="top-menu__icon"> <i data-feather="home"></i> </div>
                        <div class="top-menu__title"> Dashboard <i data-feather="chevron-down" class="top-menu__sub-icon"></i> </div>
                    </a>
                </li> */}
              {props.subTab.map((sub, index) => {
                    return( <li>
                      <a className={`top-menu ${tabactive  == index + 1 ? 'top-menu--active' : ''}`} onClick={(e) => tabactions(e, index + 1)}>
                          {/* <div className="top-menu__icon"> <i data-feather="home"></i> </div> */}
                          <div className="top-menu__title">{sub.suptitle}</div>
                      </a>
                  </li>)
              })}
            </ul>
        </nav>
      <div className="subtap_container">
        <div className="content p-5">
          {props.subTab.map((subcom, index) => {
            return (<>{tabactive == index + 1 ? <div  key={index}>
              {subcom.subcomponents}
            </div> : null}</>)
          })}
        </div>
      </div>
    </div>
  );
}
